import React, { useEffect, useState } from "react";
import axios from "axios";
import "./addpolicy.css";
import { FaPlus, FaTimes } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import Header from "../../Components/Header/header";
import * as XLSX from "xlsx";


const initialPopupData = {
    company_name: "",
    insurer_name: "",
    insurer_email: "",
    insurer_phno: "",
    tpa_name: "",
    tpa_email_id: "",
    tpa_phone: "",
};

const AddPolicy = () => {
    const [insuranceCompanies, setInsuranceCompanies] = useState([]);
    
    const [selectedCompany, setSelectedCompany] = useState(null);
    
    const [pincode, setPincode] = useState("");
    
const [branch, setBranch] = useState("");
    const [policyTypes, setPolicyTypes] = useState([]);
    const [selectedPolicyType, setSelectedPolicyType] = useState("");
    const [policyClasses, setPolicyClasses] = useState([]);
    const [selectedPolicyClass, setSelectedPolicyClass] = useState("");
    const [insurerMasters, setInsurerMasters] = useState([]);
    const [existingDocument, setExistingDocument] =
    useState("");

// =========================
// TPA STATES
// =========================

const [tpaPincode, setTpaPincode] =
    useState("");

const [tpaBranch, setTpaBranch] =
    useState("");

const [
    tpaContactPerson,
    setTpaContactPerson
] = useState("");

const [tpaPhone, setTpaPhone] =
    useState("");

const [tpaEmail, setTpaEmail] =
    useState("");

const [tpaAddress, setTpaAddress] =
    useState("");
    // const [isFetchingByBranchs, setIsFetchingByBranchs] = useState(false);
const [pausedMap, setPausedMap] = useState({});

    const [showConfirmCdPopup, setShowConfirmCdPopup] = useState(false);
    const [receiptNo, setReceiptNo] = useState("");
    const [showAddCdPopup, setShowAddCdPopup] = useState(false);
    const [isFetching, setIsFetching] = useState(true);
    const [insurerName, setInsurerName] = useState("");
    const [insurerPhone, setInsurerPhone] = useState("");
    const [insurerEmail, setInsurerEmail] = useState("");
    const [insurerAddress, setInsurerAddress] = useState("");
    const [existingBranches, setExistingBranches] = useState([]);
    const [policyName, setPolicyName] = useState("");
    const [policyNumber, setPolicyNumber] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [policyDoc, setPolicyDoc] = useState(null);
    const [policyId, setPolicyId] = useState(null);
    const [insurerExists, setInsurerExists] = useState(false);
    const [insurers, setInsurers] = useState([]);
    const [branches, setBranches] = useState([]);
    const [showSaveButton, setShowSaveButton] = useState(false);
const [tpas, setTpas] = useState([]);


const [selectedTpa, setSelectedTpa] = useState({
    tpa_id: "",
    tpa_name: "",
    pincode: "",
    tpa_branch: "",
    contact_person_name: "",
    tpa_phone: "",
    tpa_email_id: "",
    tpa_address: ""
});

    const [popupCompany, setPopupCompany] = useState("");
    const [popupBranch, setPopupBranch] = useState("");
    const [pincodes, setPincodes] = useState([]);
    const [popupPincode, setPopupPincode] = useState("");


    const [premiumAmount, setPremiumAmount] = useState("");
    const [gst, setGst] = useState("");
    const [gstAmount, setGstAmount] = useState("");
    const [totalPremium, setTotalPremium] = useState("");
    const [deductFromCD, setDeductFromCD] = useState(false);

    const [showAddressSave, setShowAddressSave] = useState(false);
    const [showTpaAddressSave, setShowTpaAddressSave] = useState(false);

    const [showPopup, setShowPopup] = useState(false);
    const [popupType, setPopupType] = useState(""); // "insurance" or "tpa"
    const [popupData, setPopupData] = useState({ ...initialPopupData });
    const [selectedDate, setSelectedDate] = useState("");
    const [insurerContacts, setInsurerContacts] = useState([]);
    const [selectedContactId, setSelectedContactId] = useState("");
const [pausedAmount, setPausedAmount] = useState(0);
    const location = useLocation();

    const [premiumRows, setPremiumRows] = useState([]); // kept for compatibility
    const [premiumFile, setPremiumFile] = useState(null); // if you still use it elsewhere

    const [cdBalance, setCdBalance] = useState(""); // store CD balance
    const [orgId, setOrgId] = useState(null);

    const [users, setUsers] = useState([]);
    const [loadingUsers, setLoadingUsers] = useState(true);
    const [user, setUser] = useState(null);
    const [isFetchingByBranch, setIsFetchingByBranch] = useState(false);
    const [showInsurerPopup, setShowInsurerPopup] = useState(false);

    const editPolicy = location.state?.policy || null;

    const [showNoCdPopup, setShowNoCdPopup] = useState(false);
    const [showCreateCdPopup, setShowCreateCdPopup] = useState(false);
    const [cdDate, setCdDate] = useState("");
    const [cdAccountNo, setCdAccountNo] = useState("");
    const [cdAmount, setCdAmount] = useState("");
    const [selectedInsurer, setSelectedInsurer] = useState(null);
    const [sumInsuredCols, setSumInsuredCols] = useState([]);
    const [showPremiumUploadPopup, setShowPremiumUploadPopup] = useState(false);
    const [branchContacts, setBranchContacts] = useState([]);


    const [errors, setErrors] = useState({ cdDate: "", receiptNo: "", cdAmount: "" });
    const [empId, setEmpId] = useState("");
    const [empName, setEmpName] = useState("");
    const [empEmail, setEmpEmail] = useState("");

    const [showExcelsumvarient, setShowExcelsumvarient] = useState(false);

    // States used for file upload
    const [file, setFile] = useState(null); // excel file for premium rates
    const [uploading, setUploading] = useState(false);

    const [cdBalances, setCdBalances] = useState({}); // store CD balances by insurer id

    // New: show popup after saving policy to allow uploading files or document
    const [showUploadPopup, setShowUploadPopup] = useState(false);
    const isEditMode = !!editPolicy; // true if editing, false if adding new


    
    


const selectedClassName = policyClasses.find(
  (c) => c.class_id === parseInt(selectedPolicyClass)
)?.class_name;

const filteredInsurers = insurerMasters.filter((insurer) => {
  if (!selectedClassName) return true;

  return insurer.insurer.includes(selectedClassName);
});
    const navigate = useNavigate();

    const resetInsurerFields = (clearBranch = true) => {
        setInsurerName("");
        setInsurerPhone("");
        setInsurerEmail("");
        setInsurerAddress("");

        if (clearBranch) {
            setBranch("");
        }
    };


    const handleTpaChange = (e) => {
    const selected = tpas.find(
        (t) => t.tpa_id === parseInt(e.target.value)
    );

    if (selected) {
        setSelectedTpa({
            ...selected,
            pincode: "",
            tpa_branch: "",
            contact_person_name: "",
            tpa_phone: "",
            tpa_email_id: "",
            tpa_address: ""
        });
    }
};



    useEffect(() => {
        if (showInsurerPopup) {
            fetch("/api/insurance-companies/insurers")
                .then(res => res.json())
                .then(data => {
                    if (data.success) setInsurers(data.data);
                });
        }
    }, [showInsurerPopup]);

    useEffect(() => {
        if (popupCompany) {
            fetch(
                `/api/insurance-companies/pincodes-by-insurer?company_name=${popupCompany}&org_id=${localStorage.getItem("org_id")}`
            )
                .then(res => res.json())
                .then(data => {
                    if (data.success) {
                        setPincodes(data.data);
                    } else {
                        setPincodes([]);
                    }
                });
        } else {
            setPincodes([]);
        }
    }, [popupCompany]);
useEffect(() => {
    if (popupCompany && popupPincode) {
        fetch(
            `/api/insurance-companies/branch-by-pincode?company_name=${popupCompany}&pincode=${popupPincode}&org_id=${localStorage.getItem("org_id")}`
        )
            .then(res => res.json())
            .then(data => {
                if (data.success && data.data.length > 0) {
                    setPopupBranch(data.data[0].branch);
                } else {
                    setPopupBranch("");
                }
            });
    }
}, [popupCompany, popupPincode]);

// useEffect(() => {
//   const fetchPausedPremium = async () => {
//     try {
//       const orgId = localStorage.getItem("org_id");

//       const res = await fetch(
//         `/api/endorsement/pending-total/${orgId}`
//       );

//       const data = await res.json();

//       if (data.success) {
//         setPausedAmount(data.total);
//       }
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   fetchPausedPremium();
// }, []);

useEffect(() => {
  const fetchPausedPremium = async () => {
    try {
      const orgId = localStorage.getItem("org_id");

      if (!selectedInsurer?.insurer) {
        setPausedAmount(0);
        return;
      }

      const res = await fetch(
        `/api/endorsement/pending-total/${orgId}/${selectedInsurer.insurer}`
      );

      const data = await res.json();

      if (data.success) {
        setPausedAmount(data.total);
      }
    } catch (err) {
      console.error(err);
    }
  };

  fetchPausedPremium();
}, [selectedInsurer]); // ✅ VERY IMPORTANT

useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setSelectedDate(today);
}, []);
    // const fetchInsurerByBranchs = async () => {
    //     if (!selectedInsurer || !branch || !pincode) return;

    //     try {
    //         setIsFetchingByBranchs(true);

    //         const res = await fetch(
    //             `/api/insurance-companies/by-branch?` +
    //             `company_name=${encodeURIComponent(selectedInsurer.insurer)}` +
    //             `&branch=${encodeURIComponent(branch)}` +
    //             `&pincode=${encodeURIComponent(pincode)}` +   // ✅ ADD THIS
    //             `&org_id=${localStorage.getItem("org_id")}`
    //         );

    //         const data = await res.json();

    //         if (data.success && data.data.length > 0) {
    //             setBranchContacts(data.data);

    //             if (data.data.length === 1) {
    //                 const c = data.data[0];
    //                 setSelectedContactId(c.id);
    //                 setInsurerName(c.insurer_name);
    //                 setInsurerPhone(c.insurer_phno);
    //                 setInsurerEmail(c.insurer_email);
    //                 setInsurerAddress(c.insurer_address);
    //             } else {
    //                 resetInsurerFields(false);
    //             }

    //             setInsurerExists(true);
    //         } else {
    //             setBranchContacts([]);
    //             setInsurerExists(false);
    //             resetInsurerFields(false);
    //         }
    //     } catch (err) {
    //         console.error(err);
    //     } finally {
    //         setIsFetchingByBranchs(false);
    //     }
    // };


    useEffect(() => {
        const storedUser = localStorage.getItem("loggedUser");
        if (storedUser) {
            const parsedUser = JSON.parse(storedUser);
            setUser(parsedUser);
            console.log("🔍 Logged User Details:", parsedUser);
        }
    }, []);

    useEffect(() => {
        const fetchRemainingCdBalance = async () => {
            if (!selectedCompany?.id) return;
            const insurerId = selectedCompany.id;

            if (cdBalances[insurerId] != null) {
                setCdBalance(cdBalances[insurerId]);
                return;
            }

            try {
                const response = await fetch(
                    `/api/policies/getRemainingCdBalance/${insurerId}`
                );
                const data = await response.json();

                let balance = 0;
                if (data.success && data.remaining_cd_balance != null) {
                    balance = Number(data.remaining_cd_balance) || 0;
                    console.log("💰 Remaining CD Balance:", balance);
                } else {
                    console.warn("⚠️ No remaining CD balance found for this insurer.");
                }

                setCdBalance(balance);
                setCdBalances((prev) => ({ ...prev, [insurerId]: balance }));
            } catch (error) {
                console.error("❌ Error fetching remaining CD balance:", error);
            }
        };

        fetchRemainingCdBalance();
    }, [selectedCompany]);

const handleBranchChange = async (branchValue) => {
    setSelectedTpa((prev) => ({
        ...prev,
        tpa_branch: branchValue,
    }));

    if (!selectedTpa?.tpa_id || !selectedTpa?.pincode || !branchValue) {
        return;
    }

    try {
        const response = await fetch(
            `/api/eb_tpa/details?tpa_id=${selectedTpa.tpa_id}&pincode=${selectedTpa.pincode}&tpa_branch=${branchValue}`
        );

        const data = await response.json();

        if (data) {
            // If record exists → auto fill
            setSelectedTpa(data);
        }
        // If null → do nothing (user can enter and save)
    } catch (err) {
        console.error("Error fetching branch details:", err);
    }
};

    const handleDownloadTemplate = () => setShowExcelsumvarient(true);
    const handleCloseExcelsumvarient = () => setShowExcelsumvarient(false);


    // Today
    const today = new Date("2025-12-09");  // OR new Date(); in real usage

    // MIN = 1 year negative
    const minStart = new Date(today);
    minStart.setFullYear(minStart.getFullYear() - 1);

    // MAX = 6 months future
    const maxStart = new Date(today);
    maxStart.setMonth(maxStart.getMonth() + 6);

    // Format YYYY-MM-DD
    const formatDate = (d) => d.toISOString().split("T")[0];

    const minStartDate = formatDate(minStart);
    const maxStartDate = formatDate(maxStart);

    const handleDownloadExcelTemplate = () => {
        const filePath = "/Templates/blukuplofofemp/sum_varient1_template.xlsx"; // change as required
        const link = document.createElement("a");
        link.href = filePath;
        link.download = "premium_templates.xlsx";
        link.click();
        setShowExcelsumvarient(false);
    };

    useEffect(() => {
        // Suppose you fetch insurer data from API
        fetch("/api/insurers")
            .then((res) => res.json())
            .then((data) => {
                const branches = data.map((insurer) => insurer.branch); // adjust according to your API
                setExistingBranches(branches);
            });
    }, []);

    // Example: check if branch already exists in your data
    const branchExists = (branchName) => {
        return existingBranches.some(
            (b) => b.toLowerCase() === branchName.toLowerCase()
        );
    };

const fetchBranchByPincode = async (pincode) => {

    try {

        console.log(
            "Fetching Pincode:",
            pincode
        );

        const response = await fetch(
            `https://api.postalpincode.in/pincode/${pincode}`
        );

        const data = await response.json();

        console.log(
            "PINCODE API RESPONSE:",
            data
        );

        // Check API success
        if (
            data &&
            data.length > 0 &&
            data[0].Status === "Success"
        ) {

            const postOffices =
                data[0].PostOffice;

            // Get Delivery office
            const deliveryOffice =
                postOffices.find(
                    (office) =>
                        office.DeliveryStatus ===
                        "Delivery"
                ) || postOffices[0];

            console.log(
                "SELECTED OFFICE:",
                deliveryOffice
            );

            // Set Branch Name
            setBranch(
                deliveryOffice.Name || ""
            );

        } else {

            console.log(
                "Invalid Pincode"
            );

            setBranch("");
        }

    } catch (error) {

        console.error(
            "Pincode Fetch Error:",
            error
        );

        setBranch("");
    }
};
 const handlePincodeChange = async (value) => {

    // numbers only
    const pincode = value.replace(/\D/g, "");

    // set pincode
    setSelectedTpa((prev) => ({
        ...prev,
        pincode,
    }));

    // clear branch if less than 6 digits
    if (pincode.length !== 6) {

        setSelectedTpa((prev) => ({
            ...prev,
            tpa_branch: "",
        }));

        return;
    }

    try {

        const res = await fetch(
            `https://api.postalpincode.in/pincode/${pincode}`
        );

        const data = await res.json();

        console.log("TPA PINCODE RESPONSE:", data);

        if (
            data[0].Status === "Success" &&
            data[0].PostOffice &&
            data[0].PostOffice.length > 0
        ) {

            // delivery office
            const deliveryOffice =
                data[0].PostOffice.find(
                    (po) =>
                        po.DeliveryStatus === "Delivery"
                ) || data[0].PostOffice[0];

            const formattedBranch =
                deliveryOffice.Name.toUpperCase();

            // set tpa branch
            setSelectedTpa((prev) => ({
                ...prev,
                tpa_branch: formattedBranch,
            }));

        } else {

            setSelectedTpa((prev) => ({
                ...prev,
                tpa_branch: "",
            }));

            alert("Invalid pincode");

        }

    } catch (err) {

        console.error(
            "TPA Pincode fetch error:",
            err
        );

        setSelectedTpa((prev) => ({
            ...prev,
            tpa_branch: "",
        }));

    }
};

    // useEffect(() => {
    //     if (!editPolicy) return;

    //     setSelectedPolicyType(editPolicy.policy_type_id || "");
    //     setSelectedPolicyClass(editPolicy.class_id || "");
    //     setPolicyName(editPolicy.policy_name || "");
    //     setPolicyNumber(editPolicy.policy_number || "");
    //     setStartDate(editPolicy.start_date ? editPolicy.start_date.split("T")[0] : "");
    //     setEndDate(editPolicy.end_date ? editPolicy.end_date.split("T")[0] : "");
    //     setPremiumAmount(editPolicy.premium_amount || "");
    //     setGst(editPolicy.gst_percent || "");
    //     setGstAmount(editPolicy.gst_amount || "");
    //     setTotalPremium(editPolicy.total_premium || "");
    //     setDeductFromCD(
    //         editPolicy.deduct_from_cd === true || editPolicy.deduct_from_cd === "true"
    //     );
    //     setCdBalance(editPolicy.cd_balance || "");
    //     setOrgId(editPolicy.org_id || "");

    //     if (editPolicy.insurance_company_id) {
    //         const selectedComp = insuranceCompanies.find(
    //             (c) => c.id === editPolicy.insurance_company_id
    //         );
    //         setSelectedCompany(selectedComp || null);
    //     }
    //     if (editPolicy.tpa_id) {
    //         const selectedT = tpas.find((t) => t.tpa_id === editPolicy.tpa_id);
    //         setSelectedTpa(selectedT || null);
    //     }
    //     setSelectedInsurer({
    //         company_id: editPolicy.insurance_company_id,
    //         insurer: editPolicy.company_name,
    //     });
    //     setBranch(editPolicy.branch || "");
    //     setInsurerName(editPolicy.insurer_name || "");
    //     setInsurerPhone(editPolicy.insurer_phno || "");
    //     setInsurerEmail(editPolicy.insurer_email || "");
    //     setInsurerAddress(editPolicy.insurer_address || "");
    //     setPolicyId(editPolicy.policy_id);
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [editPolicy, insuranceCompanies, tpas]);
useEffect(() => {

    if (!editPolicy) return;

    console.log("EDIT POLICY:", editPolicy);

    // =====================================================
    // POLICY DETAILS
    // =====================================================

    setSelectedPolicyType(
        editPolicy.policy_type_id || ""
    );

    setSelectedPolicyClass(
        editPolicy.class_id || ""
    );

    setPolicyName(
        editPolicy.policy_name || ""
    );

    setPolicyNumber(
        editPolicy.policy_number || ""
    );

    setStartDate(
        editPolicy.start_date
            ? editPolicy.start_date.split("T")[0]
            : ""
    );

    setEndDate(
        editPolicy.end_date
            ? editPolicy.end_date.split("T")[0]
            : ""
    );

    setPremiumAmount(
        editPolicy.premium_amount || ""
    );

    setGst(
        editPolicy.gst_percent || ""
    );

    setGstAmount(
        editPolicy.gst_amount || ""
    );

    setTotalPremium(
        editPolicy.total_premium || ""
    );

    setDeductFromCD(
        editPolicy.deduct_from_cd === true ||
        editPolicy.deduct_from_cd === "true"
    );

    setCdBalance(
        editPolicy.cd_balance || ""
    );

    setOrgId(
        editPolicy.org_id || ""
    );

    setPolicyId(
        editPolicy.policy_id || ""
    );

    // =====================================================
    // PINCODE + BRANCH
    // =====================================================

    setPincode(editPolicy.pincode || "");

    // ✅ IMPORTANT
    // use ONLY policyBranch everywhere
   setBranch(editPolicy.branch || "");

    // =====================================================
    // DOCUMENT
    // =====================================================

    if (typeof setExistingDocument === "function") {

        setExistingDocument(
            editPolicy.policy_document || ""
        );

    }

    // =====================================================
    // INSURER DETAILS
    // =====================================================

    setSelectedInsurer({

        company_id:
            editPolicy.insurance_company_id || "",

        insurer:
            editPolicy.company_name || ""

    });

    setSelectedCompany({

        company_name:
            editPolicy.company_name || ""

    });

    setInsurerName(
        editPolicy.insurer_name || ""
    );

    setInsurerPhone(
        editPolicy.insurer_phno || ""
    );

    setInsurerEmail(
        editPolicy.insurer_email || ""
    );

    setInsurerAddress(
        editPolicy.insurer_address || ""
    );

    // =====================================================
    // TPA DETAILS
    // =====================================================

    setSelectedTpa({

        tpa_id:
            editPolicy.tpa_id || "",

        tpa_name:
            editPolicy.tpa_name || "",

        pincode:
            editPolicy.tpa_pincode || "",

        tpa_branch:
            editPolicy.tpa_branch || "",

        contact_person_name:
            editPolicy.contact_person_name || "",

        tpa_phone:
            editPolicy.contact_person_phone || "",

        tpa_email_id:
            editPolicy.contact_person_email || "",

        tpa_address:
            editPolicy.tpa_address || ""

    });

    // =====================================================
    // OPTIONAL EXTRA STATES
    // =====================================================

    if (typeof setTpaPincode === "function") {

        setTpaPincode(
            editPolicy.tpa_pincode || ""
        );

    }

    if (typeof setTpaBranch === "function") {

        setTpaBranch(
            editPolicy.tpa_branch || ""
        );

    }

    if (typeof setTpaContactPerson === "function") {

        setTpaContactPerson(
            editPolicy.contact_person_name || ""
        );

    }

    if (typeof setTpaPhone === "function") {

        setTpaPhone(
            editPolicy.contact_person_phone || ""
        );

    }

    if (typeof setTpaEmail === "function") {

        setTpaEmail(
            editPolicy.contact_person_email || ""
        );

    }

    if (typeof setTpaAddress === "function") {

        setTpaAddress(
            editPolicy.tpa_address || ""
        );

    }

}, [editPolicy]);

    useEffect(() => {
        fetch("/api/insurer-master")
            .then(res => res.json())
            .then(data => setInsurerMasters(data))
            .catch(err => console.error(err));
    }, []);


   useEffect(() => {
    const fetchTpaDetails = async () => {
        if (
            selectedTpa?.tpa_id &&
            selectedTpa?.pincode &&
            selectedTpa?.tpa_branch
        ) {
            try {
                const res = await fetch(
                    `/api/eb_tpa/details?tpa_id=${selectedTpa.tpa_id}&pincode=${selectedTpa.pincode}&tpa_branch=${selectedTpa.tpa_branch}`
                );

                const data = await res.json();

                if (data) {
                    setSelectedTpa(data);
                }
            } catch (err) {
                console.error("Auto fetch DB error:", err);
            }
        }
    };

    fetchTpaDetails();
}, [selectedTpa?.tpa_id, selectedTpa?.pincode, selectedTpa?.tpa_branch]);




    const fetchCdBalance = async (insurerName, branchName) => {
        if (!insurerName || !branchName) {
            setCdBalance(0);
            return 0;
        }

        const storedUser = JSON.parse(localStorage.getItem("user"));
        const orgId = storedUser?.org_id;

        if (!orgId) {
            console.error("Org ID missing");
            setCdBalance(0);
            return 0;
        }

        try {
            const res = await fetch(
                `/api/latest-cd-balance?` +
                `insurer_name=${encodeURIComponent(insurerName)}` +
                `&branch=${encodeURIComponent(branchName)}` +
                `&org_id=${orgId}`
            );

            const data = await res.json();
            const balance = Number(data?.remaining_cd_balance || 0);

            setCdBalance(balance);
            return balance; // ✅ IMPORTANT
        } catch (err) {
            console.error("CD fetch error:", err);
            setCdBalance(0);
            return 0;
        }
    };


   const fetchInsurerByBranch = async (
    branchValue = branch,
    pincodeValue = pincode
) => {

    if (
        !selectedInsurer?.insurer ||
        !branchValue ||
        !pincodeValue
    ) {
        return;
    }

    try {

        setIsFetchingByBranch(true);

        console.log("FETCHING INSURER:", {
            insurer: selectedInsurer.insurer,
            branch: branchValue,
            pincode: pincodeValue
        });

        const res = await fetch(

            `/api/insurance-companies/by-branch?` +

            `company_name=${encodeURIComponent(
                selectedInsurer.insurer
            )}` +

            `&branch=${encodeURIComponent(
                branchValue
            )}` +

            `&pincode=${encodeURIComponent(
                pincodeValue
            )}` +

            `&org_id=${localStorage.getItem(
                "org_id"
            )}`

        );

        const data = await res.json();

        console.log("FETCH RESPONSE:", data);

        if (
            data.success &&
            data.data.length > 0
        ) {

            setBranchContacts(data.data);

            setInsurerExists(true);

            if (data.data.length === 1) {

                const c = data.data[0];

                setSelectedContactId(c.id);

                setInsurerName(
                    c.insurer_name || ""
                );

                setInsurerPhone(
                    c.insurer_phno || ""
                );

                setInsurerEmail(
                    c.insurer_email || ""
                );

                setInsurerAddress(
                    c.insurer_address || ""
                );

            } else {

                setSelectedContactId("");

                setInsurerName("");
                setInsurerPhone("");
                setInsurerEmail("");
                setInsurerAddress("");
            }

        } else {

            console.log("NO CONTACT FOUND");

            setBranchContacts([]);

            setInsurerExists(false);

            setSelectedContactId("");

            setInsurerName("");
            setInsurerPhone("");
            setInsurerEmail("");
            setInsurerAddress("");
        }

    } catch (err) {

        console.error(
            "FETCH ERROR:",
            err
        );

    } finally {

        setIsFetchingByBranch(false);

    }
};

    useEffect(() => {
        fetch("/api/policy_type")
            .then((res) => res.json())
            .then((data) => setPolicyTypes(Array.isArray(data) ? data : []))
            .catch((err) => console.error("Error fetching policy types:", err));


        fetch("/api/eb_tpa")
            .then((res) => res.json())
            .then((data) => setTpas(Array.isArray(data) ? data : []))
            .catch((err) => console.error("fetch tpa error:", err));

        fetch("/api/class_of_policy")
            .then((res) => res.json())
            .then((data) => setPolicyClasses(Array.isArray(data) ? data : []))
            .catch((err) => console.error("Error fetching class of policy:", err));
    }, []);

    // GST & Total Premium calculation
    useEffect(() => {
        const premium = parseFloat(premiumAmount) || 0;
        const gstPercent = parseFloat(gst) || 0;
        const gstVal = (premium * gstPercent) / 100;
        setGstAmount(gstVal.toFixed(2));
        setTotalPremium((premium + gstVal).toFixed(2));
    }, [premiumAmount, gst]);



    useEffect(() => {
        const fetchInsuranceCompanies = async () => {
            try {
                const storedUser = JSON.parse(localStorage.getItem("user")); // make sure you are storing the user as 'user'
                if (!storedUser || !storedUser.org_id) return;

                const orgId = storedUser.org_id;

                const res = await fetch(`/api/insurance_companies?org_id=${orgId}`);
                const data = await res.json();

                setInsuranceCompanies(Array.isArray(data) ? data : []);
            } catch (err) {
                console.error("fetch insurance error:", err);
            }
        };

        fetchInsuranceCompanies();
    }, []);

    const handlePolicyDocChange = (e) => {
        if (e.target.files && e.target.files[0]) setPolicyDoc(e.target.files[0]);
    };

    const openPopup = (type) => {
        setPopupType(type);
        setPopupData({ ...initialPopupData });
        setShowPopup(true);
    };

    const handlePopupChange = (e) => {
        const { name, value } = e.target;
        setPopupData((p) => ({ ...p, [name]: value }));
    };


    const handleStartDateChange = (e) => {
        const selected = e.target.value;
        setStartDate(selected);

        if (selected) {
            const end = new Date(selected);
            end.setFullYear(end.getFullYear() + 1);
            end.setDate(end.getDate() - 1); // 1 day before

            setEndDate(formatDate(end));
        }
    };

    const handleDateChange = (e) => {
        const selectedDate = new Date(e.target.value);
        const today = new Date();

        // Prevent future dates
        if (selectedDate > today) {
            alert("Future dates are not allowed.");
            return;
        }

        // Calculate the date 3 months ago
        const threeMonthsAgo = new Date();
        threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);

        if (selectedDate < threeMonthsAgo) {
            alert("Date cannot be more than 3 months in the past.");
            return;
        }

        setSelectedDate(e.target.value); // set state if valid
    };



    const handleDownloadPremiumTemplate = () => {
        const link = document.createElement("a");
        link.href = "/Templates/blukuploadofemp/premium_rates_template (1) - Copy.xlsx";
        link.download = "premium_template.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleCdYes = async () => {
        if (!selectedInsurer) {
            alert("Please select an insurer first!");
            setDeductFromCD(false);
            return;
        }

        if (!branch) {
            alert("Please enter branch first!");
            setDeductFromCD(false);
            return;
        }

        setDeductFromCD(true);

        const balance = await fetchCdBalance(
            selectedInsurer.insurer,
            branch
        );

        if (balance === 0) {
            setDeductFromCD(false);
            setShowNoCdPopup(true); // ✅ shows on FIRST click
        }
    };

    const handleSaveCD = async () => {
        if (!selectedCompany || !policyName || !policyNumber || !cdAmount) {
            alert("⚠️ Please fill in all required fields.");
            return;
        }

        try {
            const storedUser = JSON.parse(localStorage.getItem("user"));
            const orgId = storedUser?.org_id;

            // ✅ Prepare request body for API
            const requestBody = {
                cd_date: cdDate || new Date().toISOString().split("T")[0],
                cd_account_no: selectedCompany.account_no || "",
                cd_amount: Number(cdAmount),
                insurer_id: selectedCompany.id,
                policy_id: policyId || null,
                policy_number: policyNumber,
                org_id: orgId,
            };

            // ✅ Save CD deposit to backend
            const response = await fetch("/api/policies/addPolicycd", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestBody),
            });

            const data = await response.json();
            if (!response.ok || !data.success) {
                throw new Error(data.message || "Failed to add policy deposit");
            }

            alert("✅ Policy deposit added successfully!");

            const updatedBalance = (cdBalance || 0) + Number(cdAmount);
            setCdBalance(updatedBalance);

            // Also update the mapping for all companies if you maintain it
            setCdBalances((prev) => ({
                ...prev,
                [selectedCompany.id]: updatedBalance
            }));

            // ✅ Reset inputs & close popup
            setDeductFromCD(true);
            setShowCreateCdPopup(false);
            setCdAmount("");
            setCdDate("");

        } catch (error) {
            console.error("❌ Error saving policy deposit:", error);
            alert("Something went wrong while saving. Check console for details.");
        }
    };

    const handlenewvalueSaveCD = async () => {
        if (!cdAmount || Number(cdAmount) <= 0) {
            alert("⚠️ Please enter a valid CD amount");
            return;
        }

        if (!policyNumber) {
            alert("⚠️ Policy number is required");
            return;
        }

        try {
            const storedUser = JSON.parse(localStorage.getItem("user"));

            const payload = {
                cd_amount: Number(cdAmount),        // amount to add
                policy_number: policyNumber,        // key to find/update
                receipt_no: receiptNo || null,     // new receipt number
                modified_by: storedUser?.user_id || null,
            };

            const res = await fetch(
                "/api/cashdeposite/update-cd",
                {
                    method: "PUT",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload),
                }
            );

            const data = await res.json();

            if (!res.ok || !data.success) {
                throw new Error(data.message || "Failed to update CD");
            }

            // ✅ Update frontend balance with the new total returned from backend
            setCdBalance(Number(data.data.cd_amount));

            // ✅ Reset form and popups
            setDeductFromCD(true);
            setCdAmount("");
            setReceiptNo("");
            setCdDate("");
            setShowAddCdPopup(false);
            setShowConfirmCdPopup(false);

            alert("✅ CD updated successfully!");
        } catch (err) {
            console.error("❌ CD update error:", err);
            alert("Something went wrong while updating CD. Check console.");
        }
    };

    const handlePopupSave = async () => {

        if (!popupCompany) {
            alert("Please select Insurer Name");
            return;
        }
        if (!popupPincode) {
            alert("Please select Pincode");
            return;
        }

        if (!popupBranch) {
            alert("Please select Branch");
            return;
        }

        if (!insurerName.trim()) {
            alert("Please enter Contact Person name");
            return;
        }

        if (!insurerPhone.trim()) {
            alert("Please enter Contact Number");
            return;
        }

        if (!/^\d{10}$/.test(insurerPhone)) {
            alert("Contact Number must be exactly 10 digits");
            return;
        }


        if (!insurerEmail.trim()) {
            alert("Please enter Email");
            return;
        }

        // Optional email format check
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(insurerEmail)) {
            alert("Please enter a valid Email address");
            return;
        }


        try {
            const payload = {
                company_name: popupCompany,
                pincode: popupPincode,
                branch: popupBranch,
                insurer_name: insurerName,
                insurer_email: insurerEmail,
                insurer_phno: insurerPhone,
                insurer_address: insurerAddress,
                org_id: localStorage.getItem("org_id"),
                insurer_balance: 0
            };

            const res = await fetch(
                "/api/insurance-companies/new",
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload)
                }
            );

            const data = await res.json();

            if (data.success) {
                alert("Contact added successfully");
                setShowInsurerPopup(false);

                // cleanup
                setInsurerName("");
                setInsurerPhone("");
                setInsurerEmail("");
                setInsurerAddress("");
                setPopupCompany("");
                setPopupBranch("");
            }

        } catch (err) {
            console.error("Save insurer contact error", err);
        }
    };

    // policy document change
    const handleFileChangeForPolicyDoc = (e) => {
        if (e.target.files && e.target.files[0]) setPolicyDoc(e.target.files[0]);
    };

    const readExcelFile = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: "array" });
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];
                const jsonData = XLSX.utils.sheet_to_json(sheet);
                resolve(jsonData);
            };

            reader.onerror = (err) => reject(err);
            reader.readAsArrayBuffer(file);
        });
    };


    const handlePremiumFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleUploadPremiumRates = async () => {
        if (!file) return alert("Please select a file");

        try {
            const jsonData = await readExcelFile(file);
            if (!jsonData.length) return alert("Excel file is empty!");

            const rowsWithPolicy = jsonData.map((row) => ({
                ...row,
                policy_id: policyId,
            }));

            const response = await fetch("/api/premium-rates/upload", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(rowsWithPolicy),
            });

            if (response.ok) {
                alert("Premium rates uploaded successfully!");
                setShowPremiumUploadPopup(false);
                navigate("/policy-list");
            } else {
                const errorData = await response.json();
                console.error(errorData);
                alert("Error uploading premium rates");
            }
        } catch (err) {
            console.error(err);
            alert("Something went wrong: " + err.message);
        }
    };

    const handleSaveAddress = async () => {
        if (!selectedCompany?.id) {
            alert("Please select a company first.");
            return;
        }

        try {
            const response = await fetch("/update-insurer-address", {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: selectedCompany.id, insurer_address: selectedCompany.insurer_address }),
            });

            const data = await response.json();
            if (data.success) {
                alert("Address updated successfully!");
                setInsuranceCompanies((prev) =>
                    prev.map((c) => (c.id === selectedCompany.id ? { ...c, insurer_address: selectedCompany.insurer_address } : c))
                );
                setShowAddressSave(false);
            } else {
                alert("Failed to update.");
            }
        } catch (error) {
            console.error(error);
            alert("Server error.");
        }
    };

   const handleSaveTpaDetails = async () => {
    try {
        const res = await fetch("/update-tpa-details", {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(selectedTpa),
        });

        const data = await res.json();

        if (data.success) {
            alert("Saved successfully!");
        } else {
            alert("Save failed!");
        }
    } catch (err) {
        console.error(err);
    }
};

    const handleSavePolicy = async () => {
        if (
            !selectedPolicyType ||
            !selectedPolicyClass ||
            !selectedInsurer ||
            !selectedTpa ||
            !branch ||
            !pincode
        ) {
            return alert("⚠️ Please fill all required fields before saving.");
        }

        try {
            const orgId = parseInt(localStorage.getItem("org_id"), 10);

            /* -------------------------------------------------
               1️⃣ Resolve Insurance Company ID
            --------------------------------------------------*/

            let insuranceCompanyId =
                selectedCompany?.id ||
                branchContacts?.[0]?.id ||
                null;

            /* -------------------------------------------------
               2️⃣ Create insurer ONLY if ID still not found
            --------------------------------------------------*/

            if (!insuranceCompanyId) {
                const payload = {
                    company_name: selectedInsurer.insurer,
                    branch: branch,
                    pincode: pincode,
                    insurer_name: insurerName || selectedInsurer.insurer,
                    insurer_email: insurerEmail || null,
                    insurer_phno: insurerPhone || null,
                    insurer_address: insurerAddress || null,
                    org_id: orgId
                };

                const resCompany = await fetch(
                    "/api/insurance-companies",
                    {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(payload)
                    }
                );

                const dataCompany = await resCompany.json();

                if (!resCompany.ok || !dataCompany.success) {
                    return alert(
                        dataCompany.error || "Failed to create insurance company"
                    );
                }

                insuranceCompanyId = dataCompany.insurer_id;

                setSelectedCompany({
                    id: insuranceCompanyId,
                    company_name: selectedInsurer.insurer
                });
            }

            /* -------------------------------------------------
               3️⃣ Prepare policy data
            --------------------------------------------------*/

            const formData = new FormData();

            formData.append("policy_type_id", parseInt(selectedPolicyType, 10));
            formData.append("org_id", orgId);
            formData.append("class_id", parseInt(selectedPolicyClass, 10));
            formData.append("insurance_company_id", insuranceCompanyId);
            formData.append("tpa_id", parseInt(selectedTpa.tpa_id, 10));
            formData.append("policy_name", policyName || "");
            formData.append("policy_number", policyNumber || "");
            formData.append("start_date", startDate || "");
            formData.append("end_date", endDate || "");
            formData.append("deduct_from_cd", deductFromCD ? "true" : "false");
            formData.append("policy_document", policyDoc || "");
            formData.append("tpa_name", selectedTpa.tpa_name);

            // context info
            formData.append("company_name", selectedInsurer.insurer);
            formData.append("branch", branch);
            formData.append("pincode", pincode);

            /* -------------------------------------------------
               4️⃣ CD Logic (IMPORTANT FIX)
            --------------------------------------------------*/

            if (deductFromCD) {
                const cdBalanceVal = parseFloat(cdBalance) || 0;
                const premiumVal = parseFloat(premiumAmount) || 0;
                const gstVal = parseFloat(gst) || 0;

                const gstAmountVal = (premiumVal * gstVal) / 100;
                const totalPremiumVal = premiumVal + gstAmountVal;
                const remainingVal = cdBalanceVal - totalPremiumVal;

                formData.append("cd_balance", cdBalanceVal);
                formData.append("premium_amount", premiumVal);
                formData.append("gst_percent", gstVal);
                formData.append("gst_amount", gstAmountVal.toFixed(2));
                formData.append("total_premium", totalPremiumVal.toFixed(2));
                formData.append("remaining_cd_balance", remainingVal.toFixed(2));
            } else {
                // ✅ If CD = No → Save policy without CD dependency
                formData.append("cd_balance", 0);
                formData.append("premium_amount", 0);
                formData.append("gst_percent", 0);
                formData.append("gst_amount", 0);
                formData.append("total_premium", 0);
                formData.append("remaining_cd_balance", 0);
            }

            /* -------------------------------------------------
               5️⃣ Save / Update Policy
            --------------------------------------------------*/

            const url = policyId
                ? `/api/update_policy/${policyId}`
                : "/api/add_policy";

            const method = policyId ? "PUT" : "POST";

            const resPolicy = await fetch(url, {
                method,
                body: formData
            });

            const dataPolicy = await resPolicy.json();

            if (!resPolicy.ok) {
                throw new Error(
                    dataPolicy.error || "Failed to save policy"
                );
            }

            setPolicyId(dataPolicy.policy_id || policyId);

            alert(
                policyId
                    ? "✅ Policy updated successfully!"
                    : "✅ Policy created successfully!"
            );

            if (!policyId) {
                setShowPremiumUploadPopup(true);
            }

        } catch (err) {
            console.error("❌ Error saving policy:", err);
            alert("Error saving policy. Check console for details.");
        }
    };


    const handleInsurerSave = async () => {
        if (!selectedInsurer || !branch || !pincode || !insurerName || !insurerPhone) {
            return alert("Fill required fields");
        }

        try {
            const payload = {
                company_name: selectedInsurer.insurer,
                branch: branch,
                pincode: pincode,              // ✅ added
                insurer_name: insurerName,
                insurer_email: insurerEmail || null,
                insurer_phno: insurerPhone,
                insurer_address: insurerAddress || null,
                org_id: parseInt(localStorage.getItem("org_id"), 10)
            };

            const res = await fetch("/api/insurance-companies", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            });

            const data = await res.json();

            if (!res.ok || !data.success) {
                return alert(data.error || "Failed to save insurer");
            }

            setSelectedCompany({
                id: data.insurer_id,
                company_name: payload.company_name
            });

            alert("✅ Insurer saved successfully");

        } catch (err) {
            console.error("Save insurer error:", err);
            alert("Server error");
        }
    };

    return (
        <div className="addpolicy-page">
            <aside className="sidebar">
                <Header />
            </aside>

            <main className="addpolicy-content">
                <div className="addpolicy-topbar">
                    <div />
                    <div className="addpolicy-user" />
                </div>

                <section className="addpolicy-card">
                    <h2 className="addpolicy-title">Add Policy</h2>

                    <form className="addpolicy-form" onSubmit={(e) => e.preventDefault()}>
                        {/* POLICY TYPE */}
                        <div className="addpolicy-row">
                            <label className="addpolicy-label">Class of Policy</label>
                           <select
  value={selectedPolicyClass}
  onChange={(e) => {
      setSelectedPolicyClass(e.target.value);
      setSelectedInsurer(null);   // 🔥 reset insurer when class changes
  }}
>
                                <option value="">-- Select Class --</option>
                                {policyClasses.map((c) => (
                                    <option key={c.class_id} value={c.class_id}>
                                        {c.class_name}
                                    </option>
                                ))}
                            </select>
                            <label className="addpolicy-label">Policy Type</label>
                            <select value={selectedPolicyType} onChange={(e) => setSelectedPolicyType(e.target.value)}>
                                <option value="">-- Select Policy Type --</option>
                                {policyTypes.map((type) => (
                                    <option key={type.policy_id} value={type.policy_id}>
                                        {type.policy_type}
                                    </option>
                                ))}
                            </select>


                        </div>

                        <div className="section-divider" />

                        {/* INSURER SECTION */}
                        <div className="addpolicy-row">
                            {/* INSURER MASTER DROPDOWN */}
                            <label className="addpolicy-label">Insurer Name</label>
                            <div className="addpolicy-input-with-action">
                                {isEditMode ? (
                                    <input
                                        type="text"
                                        className="addpolicy-input"
                                        value={
    selectedInsurer?.insurer ||
    selectedCompany?.company_name ||
    ""
}
                                        readOnly
                                    />
                                ) : (
                                    <>
                                      <select
    className="addpolicy-input"
    value={selectedInsurer?.company_id || ""}
    onChange={(e) => {
        const insurer = filteredInsurers.find(
            (i) => i.company_id === parseInt(e.target.value)
        );
        setSelectedInsurer(insurer);
        setPausedAmount(0);
        resetInsurerFields();
    }}
>
    <option value="">-- Select Insurer --</option>

    {filteredInsurers.map((i) => (
        <option key={i.company_id} value={i.company_id}>
            {i.insurer}
        </option>
    ))}
</select>

                                        <button
                                            type="button"
                                            className="addpolicy-action-btn"
                                            onClick={() => {
                                                setShowInsurerPopup(true);

                                                // clear contact fields only
                                                setInsurerName("");
                                                setInsurerPhone("");
                                                setInsurerEmail("");
                                                setInsurerAddress("");
                                            }}
                                        >
                                            <FaPlus />
                                        </button>

                                    </>
                                )}
                            </div>

                            {/* PINCODE */}
                           <label className="addpolicy-label">
    Pincode
</label>

<input
    type="text"
    value={pincode}
    maxLength={6}
    onChange={(e) => {

        const value =
            e.target.value.replace(
                /\D/g,
                ""
            );

        setPincode(value);

        console.log(
            "Typing:",
            value
        );

        if (value.length === 6) {

            fetchBranchByPincode(
                value
            );

        } else {

            setBranch("");
        }
    }}
/>

                            {/* BRANCH */}
                           <label className="addpolicy-label">
    Branch
</label>

{console.log(
    "Current Branch State:",
    branch
)}

<input
    type="text"
    value={branch}
    readOnly
/>
                           <label className="addpolicy-label">
    Insurer Contact Person
</label>

{!isEditMode && branchContacts.length > 1 ? (

    <select
        className="addpolicy-input"
        value={selectedContactId}
        onChange={(e) => {

            const contact = branchContacts.find(
                (c) =>
                    c.id ===
                    parseInt(e.target.value)
            );

            if (contact) {

                setSelectedContactId(
                    contact.id
                );

                setInsurerName(
                    contact.insurer_name
                );

                setInsurerPhone(
                    contact.insurer_phno
                );

                setInsurerEmail(
                    contact.insurer_email
                );

                setInsurerAddress(
                    contact.insurer_address
                );
            }
        }}
    >

        <option value="">
            -- Select Contact Person --
        </option>

        {branchContacts.map((c) => (

            <option
                key={c.id}
                value={c.id}
            >
                {c.insurer_name}
            </option>

        ))}

    </select>

) : (

    <input
        className="addpolicy-input"
        type="text"
        value={
            insurerName ||
            editPolicy?.insurer_name ||
            ""
        }
        onChange={(e) =>
            setInsurerName(
                e.target.value
            )
        }
        readOnly={isEditMode}
        placeholder="Enter contact person name"
    />

)}


                            {/* PHONE */}
                            <label className="addpolicy-label">Contact No.</label>
                            <input
    className="addpolicy-input"
    type="text"
    value={
        insurerPhone ||
        editPolicy?.insurer_phno ||
        ""
    }
    maxLength={10}
    onChange={(e) =>
        setInsurerPhone(
            e.target.value
        )
    }
    readOnly={isEditMode}
/>


                            {/* EMAIL */}
                            <label className="addpolicy-label">Email</label>
                            <input
    className="addpolicy-input"
    type="email"
    value={
        insurerEmail ||
        editPolicy?.insurer_email ||
        ""
    }
    placeholder="example@email.com"
    onChange={(e) =>
        setInsurerEmail(
            e.target.value
        )
    }
    readOnly={isEditMode}
/>

                            {/* ADDRESS */}
                            <label className="addpolicy-label">Address</label>
                            <textarea
    className="addpolicy-input"
    rows={3}
    value={
        insurerAddress ||
        editPolicy?.insurer_address ||
        ""
    }
    onChange={(e) =>
        setInsurerAddress(
            e.target.value
        )
    }
    readOnly={isEditMode}
/>

                            {/* SAVE */}
                            {!isEditMode && !isFetchingByBranch && !insurerExists && branch && (
                                <div style={{ marginTop: "12px", textAlign: "right" }}>
                                    
                                </div>
                            )}


                        </div>

                       

                        <div className="section-divider" />

                        {/* POLICY DETAILS */}
                        <div className="addpolicy-row">
                            <label className="addpolicy-label">Policy Name</label>
                            <input className="addpolicy-input" type="text" value={policyName} onChange={(e) => setPolicyName(e.target.value)} maxLength={15} />

                            <label className="addpolicy-label">Policy Number</label>
                            <input className="addpolicy-input" type="text" value={policyNumber} onChange={(e) => setPolicyNumber(e.target.value)} maxLength={20} />
                        </div>

                        <div className="addpolicy-row">
                            <label className="addpolicy-label">Start Date</label>
                            <input
                                className="addpolicy-input"
                                type="date"
                                value={startDate}
                                min={minStartDate}   // 09-12-2024
                                max={maxStartDate}   // 09-06-2026
                                onChange={handleStartDateChange}
                            />

                            <label className="addpolicy-label">End Date</label>
                            <input
                                className="addpolicy-input"
                                type="date"
                                value={endDate}
                                readOnly
                            />
                        </div>

{/* TPA DETAILS */}

 <div className="section-divider" />
<div className="addpolicy-row">

    {/* TPA DROPDOWN */}
    <label className="addpolicy-label">TPA</label>
    <select
        className="addpolicy-input"
        value={selectedTpa?.tpa_id || ""}
        onChange={(e) => {
            const selected = tpas.find(
                (t) => t.tpa_id === parseInt(e.target.value)
            );

            if (selected) {
                setSelectedTpa({
                    ...selected,
                    pincode: "",
                    tpa_branch: "",
                    contact_person_name: "",
                    tpa_phone: "",
                    tpa_email_id: "",
                    tpa_address: ""
                });
                setShowSaveButton(false);
            }
        }}
    >
        <option value="">-- Select TPA --</option>
        {tpas.map((t) => (
            <option key={t.tpa_id} value={t.tpa_id}>
                {t.tpa_name}
            </option>
        ))}
    </select>

    {/* PINCODE */}
    <label className="addpolicy-label">TPA Pincode</label>
    <input
        className="addpolicy-input"
        type="text"
        value={selectedTpa?.pincode || ""}
        maxLength={6}
        onChange={(e) => handlePincodeChange(e.target.value)}
        placeholder="Enter pincode"
    />

    {/* BRANCH */}
    <label className="addpolicy-label">Branch</label>
    <input
        className="addpolicy-input"
        type="text"
        value={selectedTpa?.tpa_branch || ""}
        onChange={(e) =>
            setSelectedTpa((prev) => ({
                ...prev,
                tpa_branch: e.target.value
            }))
        }
    />

    {/* CONTACT PERSON */}
    <label className="addpolicy-label">Contact Person Name</label>
    <input
        className="addpolicy-input"
        type="text"
        value={selectedTpa?.contact_person_name || ""}
        onFocus={() => setShowSaveButton(true)}
        onChange={(e) => {
            const onlyLetters = e.target.value.replace(/[^a-zA-Z\s]/g, "");
            setSelectedTpa((prev) => ({
                ...prev,
                contact_person_name: onlyLetters
            }));
        }}
    />

    {/* PHONE */}
    <label className="addpolicy-label">Contact No.</label>
    <input
        className="addpolicy-input"
        type="text"
        maxLength={10}
        value={selectedTpa?.tpa_phone || ""}
        onChange={(e) => {
            const onlyNumbers = e.target.value.replace(/\D/g, "");
            setSelectedTpa((prev) => ({
                ...prev,
                tpa_phone: onlyNumbers
            }));
        }}
    />

    {/* EMAIL */}
    <label className="addpolicy-label">Email</label>
    <input
        className="addpolicy-input"
        type="email"
        value={selectedTpa?.tpa_email_id || ""}
        onChange={(e) =>
            setSelectedTpa((prev) => ({
                ...prev,
                tpa_email_id: e.target.value
            }))
        }
    />

    {/* ADDRESS */}
    <label className="addpolicy-label">Address</label>
    <textarea
        className="addpolicy-input"
        rows={3}
        value={selectedTpa?.tpa_address || ""}
        onChange={(e) =>
            setSelectedTpa((prev) => ({
                ...prev,
                tpa_address: e.target.value
            }))
        }
    />

</div>

{/* SHOW SAVE BUTTON ONLY AFTER CLICKING CONTACT NAME */}
{showSaveButton && (
    <button
        type="button"
        className="addpolicy-action-btn"
        onClick={() => {
            // simple email validation
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (!emailRegex.test(selectedTpa.tpa_email_id)) {
                alert("Enter valid email");
                return;
            }

            if (selectedTpa.tpa_phone.length !== 10) {
                alert("Phone number must be 10 digits");
                return;
            }

            handleSaveTpaDetails();
        }}
    >
        Save
    </button>
)}
                 <div className="section-divider" />
               <div className="cd-box">
  <div className="addpolicy-row">
    <label className="addpolicy-label">Link to CD Balance</label>

    <div className="addpolicy-checkbox-group">
      <label>
        <input
          type="radio"
          checked={!deductFromCD}
          onChange={() => setDeductFromCD(false)}
        />
        No
      </label>

      <label>
        <input
          type="radio"
          checked={deductFromCD}
          onChange={handleCdYes}
        />
        Yes
      </label>
    </div>
  </div>

  {deductFromCD && (
    <>
      {(() => {
        const availableBalance = cdBalance - pausedAmount;

        return (
          <>
            {/* ✅ ROW 1 */}
            <div className="addpolicy-row">
              <label className="addpolicy-label">CD Balance</label>
              <input
                className="addpolicy-input"
                type="number"
                value={cdBalance || ""}
                readOnly
              />

              <label className="addpolicy-label">Premium Amount</label>
              <input
                className="addpolicy-input"
                type="number"
                value={premiumAmount === "" ? "" : premiumAmount}
                onChange={(e) => {
                  const value = e.target.value;

                  if (value === "") {
                    setPremiumAmount("");
                    return;
                  }

                  const premium = Number(value);
                  const gstAmt = (premium * gst) / 100;
                  const total = premium + gstAmt;

                  if (total > availableBalance) {
                    setShowConfirmCdPopup(true);
                    return;
                  }

                  setPremiumAmount(premium);
                }}
              />

              <label className="addpolicy-label">GST %</label>
              <input
                className="addpolicy-input"
                type="number"
                value={gst}
                onChange={(e) => {
                  const newGst = Number(e.target.value);
                  const gstAmt = (premiumAmount * newGst) / 100;
                  const total = Number(premiumAmount) + gstAmt;

                  if (total > availableBalance) {
                    setShowConfirmCdPopup(true);
                    return;
                  }

                  setGst(newGst);
                }}
              />
            </div>

            {/* 🔥 HOLD NOTE (CORRECT PLACE) */}
            {pausedAmount > 0 && (
              <div style={{ marginTop: "5px", marginBottom: "10px" }}>
                <span style={{ color: "red", fontSize: "14px", fontWeight: "500" }}>
                  Note: ₹ {pausedAmount.toFixed(2)} is on hold (Pending Endorsements)
                </span>
              </div>
            )}

            {/* ✅ ROW 2 */}
            <div className="addpolicy-row">
              <label className="addpolicy-label">GST Amount</label>
              <input
                className="addpolicy-input"
                type="text"
                readOnly
                value={((premiumAmount * gst) / 100 || 0).toFixed(2)}
              />

              <label className="addpolicy-label">Total Premium</label>
              <input
                className="addpolicy-input"
                type="text"
                readOnly
                value={(
                  Number(premiumAmount) +
                  (premiumAmount * gst) / 100 || 0
                ).toFixed(2)}
              />

              {!isEditMode && (
                <>
                  <label className="addpolicy-label">
                    Remaining CD Balance
                  </label>
                  <input
                    className="addpolicy-input"
                    type="text"
                    readOnly
                    value={(
                      cdBalance -
                      pausedAmount -
                      (Number(premiumAmount) +
                        (premiumAmount * gst) / 100 || 0)
                    ).toFixed(2)}
                  />
                </>
              )}
            </div>
          </>
        );
      })()}
    </>
  )}
</div>

                        <div className="section-divider" />

                        {/* DOCUMENT UPLOAD SECTION */}
                        <div className="addpolicy-row document-row">
                            <div style={{ padding: "30px" }}>
                                <label className="addpolicy-label">Policy Document</label>
                                <input className="doc-file-input" type="file" onChange={handleFileChangeForPolicyDoc} />
                            </div>

                        </div>

                        <div className="addpolicy-row" style={{ justifyContent: "center", marginTop: "20px" }}>
                            <button type="button" className="addpolicy-save-btn" onClick={handleSavePolicy}>
                                Save Policy
                            </button>
                        </div>
                    </form>
                </section>

                {/* POPUP */}
                {showPopup && popupType === "insurance" && (
                    <div className="addpolicy-popup-overlay">
                        <div className="addpolicy-popup">
                            <div className="addpolicy-popup-header">
                                <h3 className="addpolicy-popup-title">Add Insurer</h3>
                                <button
                                    className="addpolicy-popup-close"
                                    onClick={() => setShowPopup(false)}
                                >
                                    <FaTimes />
                                </button>
                            </div>

                            <div className="addpolicy-popup-body">
                                <label>Insurer Name</label>
                                <input
                                    name="insurer_name"
                                    value={popupData.insurer_name || ""}
                                    onChange={handlePopupChange}
                                />

                                <label>Email</label>
                                <input
                                    name="insurer_email"
                                    type="email"
                                    value={popupData.insurer_email || ""}
                                    onChange={handlePopupChange}
                                />

                                <label>Phone</label>
                                <input
                                    name="insurer_phno"
                                    value={popupData.insurer_phno || ""}
                                    onChange={handlePopupChange}
                                />
                            </div>

                            <div className="addpolicy-popup-footer">
                                <button className="save-btn" onClick={handlePopupSave}>
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                )}


                {/* No CD popup */}
                {showNoCdPopup && (
                    <div className="popup-overlay">
                        <div className="popup">
                            <h3>No CD balance found</h3>
                            <p>This insurer does not have any CD balance. Do you want to create one?</p>
                            <div className="popup-actions">
                                <button className="btn btn-secondary" onClick={() => setShowNoCdPopup(false)}>
                                    Cancel
                                </button>
                                <button
                                    className="btn btn-primary"
                                    onClick={() => {
                                        setShowNoCdPopup(false);
                                        setShowCreateCdPopup(true);
                                    }}
                                >
                                    Create CD
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Create CD popup */}
                {showCreateCdPopup && (
                    <div className="popup-overlay">
                        <div className="popup">
                            <h3>Create Cash Deposit</h3>

                           <label>Date:</label>
<input
    type="date"
    value={selectedDate}
    readOnly
/>


                            <label>Account Number:</label>
                            <input
                                type="text"
                                value={selectedCompany ? selectedCompany.account_no || "" : ""}
                                onChange={(e) => setSelectedCompany((prev) => ({ ...prev, account_no: e.target.value }))}
                                maxLength={14}
                            />
                            <label>Amount:</label>
                            <input type="number" value={cdAmount} onChange={(e) => setCdAmount(e.target.value)} />
                            <div className="popup-actions">
                                <button className="btn btn-secondary" onClick={() => setShowCreateCdPopup(false)}>
                                    Cancel
                                </button>
                                <button className="btn btn-primary" onClick={handleSaveCD}>
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {showExcelsumvarient && (
                    <div className="excelsumvarient-overlay">
                        <div className="excelsumvarient-card">
                            <div className="excelsumvarient-header">
                                <label className="excelsumvarient-label"> SumInsure Variant 1 </label>
                                <button className="excelsumvarient-download-btn" onClick={handleDownloadExcelTemplate}>
                                    Download Excel Template
                                </button>
                            </div>

                            <button className="excelsumvarient-close" onClick={handleCloseExcelsumvarient}>
                                ✖
                            </button>
                        </div>
                    </div>
                )}

                {/* Upload popup shown after saving policy (optional) */}
                {showPremiumUploadPopup && (
                    <div className="premium-popup-overlay">
                        <div className="premium-popup-container">
                            <h3 className="premium-popup-title">Upload Premium Rates</h3>
                            <p className="premium-popup-policy">
                                Policy ID: <b>{policyId}</b>
                            </p>
                            <label className="premium-popup-label">Select Excel File</label>
                            <input
                                type="file"
                                accept=".xlsx,.xls"
                                onChange={handlePremiumFileChange}
                                className="premium-popup-fileinput"
                            />
                            <div className="premium-popup-actions">

                                <button
                                    className="premium-popup-btn secondary"
                                    onClick={handleDownloadPremiumTemplate}
                                >
                                    Download Template
                                </button>
                                <button className="premium-popup-btn primary" onClick={handleUploadPremiumRates}>
                                    Upload
                                </button>
                                <button className="premium-popup-btn secondary" onClick={() => setShowPremiumUploadPopup(false)}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>

                )}
                {showConfirmCdPopup && (
                    <div className="popup-overlay">
                        <div className="popup">
                            <h3>CD Balance Insufficient</h3>
                            <p>Your premium amount is more than the CD balance. Do you want to add amount?</p>

                            <div className="popup-actions">
                                <button
                                    onClick={() => setShowConfirmCdPopup(false)}
                                >
                                    No
                                </button>

                                <button
                                    onClick={() => {
                                        setShowConfirmCdPopup(false);
                                        navigate("/cd-balance"); // ✅ redirect
                                    }}
                                >
                                    Yes
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {showAddCdPopup && (
                    <div className="popup-overlay">
                        <div className="popup">
                            <h3>Create CD</h3>

                            <label>Date:</label>
                            <input
                                type="date"
                                value={cdDate}
                                onChange={e => setCdDate(e.target.value)}
                            />
                            <span className="error-text">{errors.cdDate}</span>

                            <label>Receipt:</label>
                            <input
                                type="text"
                                value={receiptNo}
                                onChange={e => setReceiptNo(e.target.value)}
                            />
                            <span className="error-text">{errors.receiptNo}</span>

                            <label>Amount:</label>
                            <input
                                type="number"
                                value={cdAmount}
                                onChange={e => setCdAmount(e.target.value)}
                            />
                            <span className="error-text">{errors.cdAmount}</span>

                            <div className="popup-actions">
                                <button onClick={() => setShowAddCdPopup(false)}>
                                    Cancel
                                </button>
                                <button onClick={handleSaveCD}>
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {showInsurerPopup && (
                    <div className="insurer-contact-overlay">
                        <div className="insurer-contact-popup">

                            <div className="insurer-contact-header">
                                <h3>Add Insurer Contact</h3>
                                <button onClick={() => setShowInsurerPopup(false)}>✕</button>
                            </div>

                            <div className="insurer-contact-form">

                                {/* INSURER */}
                                <div className="form-group">
                                    <label>
                                        Insurer Name <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <select
                                        value={popupCompany}
                                        onChange={(e) => {
                                            setPopupCompany(e.target.value);
                                            setPopupPincode("");
                                            setPopupBranch("");
                                        }}
                                    >
                                        <option value="">-- Select Insurer --</option>
                                        {insurers.map((i, idx) => (
                                            <option key={idx} value={i.company_name}>
                                                {i.company_name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* PINCODE */}
                                <div className="form-group">
                                    <label>
                                        Pincode <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <select
                                        value={popupPincode}
                                        onChange={(e) => setPopupPincode(e.target.value)}
                                        disabled={!popupCompany}
                                    >
                                        <option value="">-- Select Pincode --</option>
                                        {pincodes.map((p, idx) => (
                                            <option key={idx} value={p.pincode}>
                                                {p.pincode}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* BRANCH (AUTO FILLED) */}
                                <div className="form-group">
                                    <label>
                                        Branch <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                        value={popupBranch}
                                        placeholder="Branch will auto fill"
                                        disabled
                                    />
                                </div>

                                {/* CONTACT PERSON */}
                                <div className="form-group">
                                    <label>
                                        Contact Person <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                        value={insurerName}
                                        onChange={(e) => setInsurerName(e.target.value)}
                                    />
                                </div>

                                {/* CONTACT NO */}
                                <div className="form-group">
                                    <label>
                                        Contact No <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                        value={insurerPhone}
                                        maxLength={10}
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/\D/g, ""); // numbers only
                                            setInsurerPhone(value);
                                        }}
                                        placeholder="Enter 10-digit phone number"
                                    />

                                </div>

                                {/* EMAIL */}
                                <div className="form-group">
                                    <label>
                                        Email <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                        type="email"
                                        value={insurerEmail}
                                        onChange={(e) => setInsurerEmail(e.target.value)}
                                        placeholder="example@mail.com"
                                    />
                                </div>

                                {/* ADDRESS */}
                                <div className="form-group full-width">
                                    <label>Address</label>
                                    <textarea
                                        rows={3}
                                        value={insurerAddress}
                                        onChange={(e) => setInsurerAddress(e.target.value)}
                                    />
                                </div>

                                {/* ACTIONS */}
                                <div className="form-actions">
                                    <button
                                        className="addpolicy-save-btn"
                                        onClick={handlePopupSave}
                                        disabled={
                                            !popupCompany ||
                                            !popupPincode ||
                                            !popupBranch ||
                                            !insurerName ||
                                            !insurerPhone
                                        }
                                    >
                                        Save Contact
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                )}
            </main>
        </div>
    );
};

export default AddPolicy;
